import { Link } from "react-router-dom";

const inputCls = "w-full bg-[#FFFFFF] border border-[#E7DFD5] px-4 py-3.5 text-sm text-[#1C1917] placeholder:text-[#A8A29E] focus:outline-none focus:border-[#F59E0B] transition-colors duration-300";

const Field = ({ label, children }) => (
  <div>
    <label className="block font-mono text-[10px] tracking-[0.3em] uppercase text-[#78716C] mb-2">{label}</label>
    {children}
  </div>
);

export const AuthFields = ({ form, setForm, isLogin }) => {
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  return (
    <>
      {!isLogin && (
        <Field label="Name">
          <input data-testid="auth-name" required value={form.name} onChange={set("name")} className={inputCls} placeholder="Your name" />
        </Field>
      )}
      <Field label="Email">
        <input data-testid="auth-email" type="email" required value={form.email} onChange={set("email")} className={inputCls} placeholder="you@email.com" />
      </Field>
      <Field label="Password">
        <input data-testid="auth-password" type="password" required minLength={6} value={form.password} onChange={set("password")} className={inputCls} placeholder="••••••••" />
      </Field>
      {!isLogin && (
        <label className="flex items-start gap-3 cursor-pointer" data-testid="auth-terms-label">
          <input type="checkbox" checked={form.accepted_terms} onChange={set("accepted_terms")} className="mt-1 accent-[#F59E0B]" data-testid="auth-terms" />
          <span className="text-xs text-[#78716C] leading-relaxed">
            I agree to the <Link to="/terms" className="text-[#B45309] underline underline-offset-2" data-testid="auth-terms-link">Terms of Service</Link> and <Link to="/privacy" className="text-[#B45309] underline underline-offset-2" data-testid="auth-privacy-link">Privacy Policy</Link>. T.A.C.C. is run by A.BC.D.F.LLC and is not medical care.
          </span>
        </label>
      )}
    </>
  );
};
